import { IconCountType } from 'ui-components/contents/IconCount';

export const getIconCountMap = (
  iconCounts: IconCountType[],
  {
    viewCount,
    replyCount,
    favoriteCount,
    recommendCount,
    newEpisodeNotiCount,
  }: {
    viewCount?: number;
    replyCount?: number;
    favoriteCount?: number;
    recommendCount?: number;
    newEpisodeNotiCount?: number;
  },
) => {
  const subMetaCountMap = {
    [IconCountType.View]: viewCount ?? 0,
    [IconCountType.Reply]: replyCount ?? 0,
    [IconCountType.Favorite]: favoriteCount ?? 0,
    [IconCountType.Recommend]: recommendCount ?? 0,
    [IconCountType.NewEpisodeNoti]: newEpisodeNotiCount ?? 0,
  };

  return iconCounts.reduce(
    (acc, cur) => ({
      ...acc,
      [cur]: subMetaCountMap[cur],
    }),
    {},
  ) as Record<IconCountType, number>;
};
